import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'hb-tooltip-component',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() public text: string;
  @Input() public relativePosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() public width?: number;

  @Input() public hideTip ? = true;
  @Input() public hideShadow ? = true;
  @Input() public isLarge ? = false;

  @Input() public theme: 'light' | 'dark' = 'dark';

  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  public isVisible = true;

  constructor() {}

  ngOnInit() {
    this.isVisible = true;
  }

  public closeTooltip() {
    this.isVisible = false;
    this.onClose.emit(false);
  }
}
